module.exports = __webpack_public_path__ + "static/img/press5.4ad67ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/press5.png
// module id = Vn5k
// module chunks = 0